import { EnergyType, PriceList, Product } from '@boltenergy-be/shared'
import { FormatContractStatus } from 'types/contracts.ts'

export const TARIFF_LOG_COLUMNS = {
  download: 'download',
  end: 'end',
  energyType: 'energyType',
  product: 'product',
  start: 'start',
  status: 'status'
}
export type TariffLogColumnKeys = (typeof TARIFF_LOG_COLUMNS)[keyof typeof TARIFF_LOG_COLUMNS]

export type LogbookEntry = PriceList & {
  id: string
  product?: Product
  status: FormatContractStatus['key']
  energyType: EnergyType
}
